import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllTimeSheetCount = createAsyncThunk(
    'report/fetchAllTimesheetReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/report/timesheet/count');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all TimeSheet Report');
        }
    }
);
export const fetchAllWorkingHoursMonthly = createAsyncThunk(
    'report/fetchAllTimesheetReport',
    async (year: string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/timesheet/workinghrs/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all TimeSheet MOnthly Report');
        }
    }
);
export const fetchAllEmployeeData = createAsyncThunk(
    'report/fetchAllEmployeeTimesheetReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/timesheet/employee`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Employee TimeSheet');
        }
    }
);
export const fetchAllLogByemployeeId = createAsyncThunk(
    'report/fetchAllEmployeeTimesheetReport',
    async (employeeId: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/worklogs/timesheetlog/${employeeId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Employee TimeSheet');
        }
    }
);
export const fetchWorklogsBySupervisorHierarchy = createAsyncThunk(
    "worklogs/fetchWorklogsBySupervisorHierarchy",
    async (
        { supervisorId, includeSelf = false }: { supervisorId: number; includeSelf?: boolean },
        { rejectWithValue }
    ) => {
        try {
            const response = await employeeServiceApiInstance.get(
                `/worklogs/supervisor/${supervisorId}`,
                { params: { includeSelf } }
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data || "Failed to fetch supervisor hierarchy worklogs"
            );
        }
    }
);
